import Utils from "../../utils/Utils";
import Validator from "../../utils/Validator";
import ClientDialog from "./ClientDialog";

/**
 * "dialog clean-up dialog"
 */
export default class DlgCleanupDlg extends ClientDialog {

    /**
     * constructs a new instance
     * @param {CliCbkWdg} cbw callback widget
     * @param {String} idw ID of target widget (dialog) 
     * @param {*} icon dialog icon
     * @param {*} param dialog parameters
     */
    constructor(cbw, idw, icon, param) {
        super('dlg.misc.DlgCleanupDlg', icon, param);
        this.cbkWdg = cbw;
        this.wdgId = idw || '';
        this.checkMap = new Map();
    }

    /**
     * @override
     */
    doDestroy() {
        this._notify('close');
        this.checkMap.clear();
        delete this.checkMap;
        delete this.cbkWdg;
        delete this.idw;
        super.doDestroy();
    }

    /**
     * @override
     * @param {HTMLElement} hdr_frame the header frame
     * @param {HTMLElement} body_frame the body frame
     * @param {HTMLElement} btn_frame  the button frame
     */
    renderDlg(hdr_frame, body_frame, btn_frame) {
        const param = this.dlgPar;
        const what = param.what || {};
        const idw = this.wdgId;
        const map = this.checkMap;
        map.clear();
        Object.getOwnPropertyNames(param).forEach((name) => {
            if ( name.startsWith('chk_') ) {
                const cid = idw + '_' + name;
                const line = document.createElement('div');
                line.className = 'dlgline';
                const check = document.createElement('input');
                check.id = cid;
                check.type = 'checkbox';
                check.classList.add('dlgcheckbox');
                check.name = name;

                const checked = !!what[name];
                check.checked = checked;

                map.set(name, check);
                const label = document.createElement('label');
                label.className = 'dlglabel';
                label.htmlFor = cid;
                label.innerHTML = Utils.escHtml(param[name] || '');
                line.appendChild(check);
                line.appendChild(label);
                body_frame.appendChild(line);
            }
        });

        const btn_clear = document.createElement('div');
        btn_clear.classList.add('dlgbtn');
        btn_clear.classList.add('dlgcommonbtn');
        btn_clear.innerHTML = Utils.escHtml(param.btn_oky || 'Reset');

        const btn_cancel = document.createElement('div');
        btn_cancel.classList.add('dlgbtn');
        btn_cancel.classList.add('dlgcommonbtn');
        btn_cancel.innerHTML = Utils.escHtml(param.btn_can || 'Cancel');

        btn_frame.appendChild(btn_clear);
        btn_frame.appendChild(btn_cancel);

        const self = this;
        btn_clear.addEventListener('click', () => {
            self._onReset();
        });
        btn_cancel.addEventListener('click', () => {
            self.close();
        });
    }

    /**
     * sends a notification
     * @param {String} code notification code
     * @param {*} param notification parameters
     */
    _notify(code, param) {
        const idw = this.wdgId;
        if ( Validator.isString(idw) ) {
            this.cbkWdg.nfySrv(idw, code, param || {}, null);
        }
    }

    _onReset() {
        const param = {};
        const map = this.checkMap;
        map.forEach((value, key) => {
            if ( value instanceof HTMLInputElement ) {
                param[key] = value.checked;
            }
        });
        this._notify('reset', param);
        this.close();
    }
}